import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ScrollbarWidthService {
  private _cache: { px: number; str: string } | undefined;

  public scrollbarWidthPx(): number {
    return this.getCache().px;
  }

  public scrollbarWidth(): string {
    return this.getCache().str;
  }

  private getCache(): { px: number; str: string } {
    if (!this._cache) {
      const px = this.measure();
      this._cache = { px, str: `${px}px` };
    }
    return this._cache;
  }

  private measure(): number {
    const div = document.createElement("div");
    div.style.cssText =
      // eslint-disable-next-line catalyst/localize-message
      "width:100px;height:100px;overflow:scroll;position:absolute;top:-9999px";
    document.body.appendChild(div);

    const scrollbarWidth = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);

    return Math.max(scrollbarWidth, 0);
  }
}
